/* TK Video carousel (PDP) — pás náhledů videí vedle sebe + lightbox s přehrávačem.
   Markup: snippets/tk-video-carousel.liquid, layout: assets/tk-product-tabs.css (.tk-vc, .tk-vcl).

   PÁS = skutečný scroll (`.tk-vc__track`, scroll-snap), takže swipe prstem,
   trackpad a kolečko jedou nativně. Tady se navíc řeší:
   - šipky / tečky / klávesnice → scrollTo na začátek daného slidu,
   - tažení MYŠÍ (pointerType mouse): během tahu se vypne snap (jinak Chrome
     při každé změně scrollLeft znovu dosnapuje a pás cuká) a po puštění se
     dosnapuje na nejbližší slide; klik, který tah vyrobí, se zahodí,
   - počitadlo a tečky podle prvního viditelného slidu,
   - když se všechna videa vejdou bez scrollu, šipky i tečky se schovají
     (`tk-vc--static`), pás je pak centrovaný přes `justify-content: safe center`,
   - název + autor videa z YouTube oEmbed (veřejné, bez klíče, CORS povolené)
     do `.tk-vc__caption` — až když karusel přijede do zorného pole, cache
     v sessionStorage, chyba = popisek prostě zůstane prázdný. V lightboxu
     jsou z toho prokliky: titulek → video, autor → kanál (author_url),
     tlačítko „Otevřít na YouTube" → video (Short = /shorts/<id>).

   LIGHTBOX = jeden <dialog class="tk-vcl"> pro celou stránku, vyrobený až při
   prvním kliknutí. V pásu se do té doby nenačte žádný přehrávač (jen náhledy).
   - 16:9: iframe youtube-nocookie s autoplay a ovládáním,
   - Short: klon <template data-tk-vc-short-tpl> (markup tk-short-embed: controls=0,
     štít, tlačítko na ovládání) + autoplay; handshake a štít obsluhuje
     tk-product-tabs.js přes svůj MutationObserver, tady se nic neduplikuje.
   Zavření (křížek, klik mimo, Esc) přehrávač odstraní = video se zastaví.
   Scroll stránky se zamyká přes třídu na <html> (overflow: hidden), ne přes
   position: fixed na body, aby se stránka neposunula.

   Re-init po změně varianty: product-tabs se přepíší přes innerHTML a pošlou
   `tk:product-tabs-updated`. */
(function () {
  'use strict';

  /* ────────────────────────── lightbox ────────────────────────── */
  var lightbox = null;

  function buildLightbox(closeLabel, ytLabel) {
    var dlg = document.createElement('dialog');
    dlg.className = 'tk-vcl';
    dlg.innerHTML =
      // tabindex=-1 + autofocus: showModal() by jinak dal fokus prvnímu tlačítku (křížek)
      // a iOS Safari mu nechá focus ring + lepkavý hover, dokud se neklepne jinam.
      '<div class="tk-vcl__inner" tabindex="-1" autofocus>' +
        '<button type="button" class="tk-vcl__close" data-tk-vcl-close aria-label="' + (closeLabel || 'Zavřít').replace(/"/g, '&quot;') + '">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="tk-vcl__frame" data-tk-vcl-frame></div>' +
        '<div class="tk-vcl__caption" data-tk-vcl-caption>' +
          '<div class="tk-vcl__meta">' +
            '<a class="tk-vcl__title" data-tk-vcl-title target="_blank" rel="noopener"></a>' +
            '<a class="tk-vcl__author" data-tk-vcl-author target="_blank" rel="noopener"></a>' +
          '</div>' +
          '<a class="tk-vcl__yt" data-tk-vcl-yt target="_blank" rel="noopener">' + '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M23 7.5a3 3 0 0 0-2.1-2.1C19 5 12 5 12 5s-7 0-8.9.4A3 3 0 0 0 1 7.5 31 31 0 0 0 .6 12 31 31 0 0 0 1 16.5a3 3 0 0 0 2.1 2.1C5 19 12 19 12 19s7 0 8.9-.4a3 3 0 0 0 2.1-2.1A31 31 0 0 0 23.4 12 31 31 0 0 0 23 7.5zM9.8 15.1V8.9L15.7 12l-5.9 3.1z"/></svg>' + '<span>' + (ytLabel || 'YouTube') + '</span></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);

    var frame = dlg.querySelector('[data-tk-vcl-frame]');

    function close() {
      if (!dlg.open) return;
      dlg.close();
    }
    dlg.querySelector('[data-tk-vcl-close]').addEventListener('click', close);
    // Klik na backdrop = mimo vnitřní box
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close();
    });
    // `close` event pokrývá křížek, backdrop i Esc (native cancel → close)
    dlg.addEventListener('close', function () {
      frame.innerHTML = '';
      dlg.classList.remove('is-open', 'tk-vcl--vertical');
      document.documentElement.classList.remove('tk-vcl-open');
      if (dlg._returnTo && dlg._returnTo.focus) {
        try { dlg._returnTo.focus({ preventScroll: true }); } catch (err) {}
      }
      dlg._returnTo = null;
    });

    return {
      el: dlg,
      open: function (slide, opener) {
        var id = slide.getAttribute('data-tk-vc-yt');
        var vertical = slide.hasAttribute('data-tk-vc-vertical');
        if (!id) return;

        frame.innerHTML = '';
        dlg.classList.toggle('tk-vcl--vertical', vertical);
        // Crop pravidla pro Short (iframe[data-tk-short]) jsou vázaná na tuhle třídu
        frame.classList.toggle('tk-promo-video__frame--vertical', vertical);

        if (vertical) {
          var tpl = slide.querySelector('[data-tk-vc-short-tpl]');
          if (tpl && tpl.content) {
            var node = tpl.content.cloneNode(true);
            var ifr = node.querySelector('iframe');
            if (ifr) {
              ifr.removeAttribute('loading');
              ifr.src = ifr.getAttribute('src') + '&autoplay=1';
            }
            frame.appendChild(node);
          }
        } else {
          var iframe = document.createElement('iframe');
          iframe.className = 'tk-vcl__player';
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.title = (slide.querySelector('[data-tk-vc-title]') || {}).textContent || 'YouTube';
          frame.appendChild(iframe);
        }

        // Prokliky: titulek → video, autor → kanál (author_url z oEmbed), tlačítko → video
        var videoUrl = vertical
          ? 'https://www.youtube.com/shorts/' + encodeURIComponent(id)
          : 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
        var t = slide.querySelector('[data-tk-vc-title]');
        var a = slide.querySelector('[data-tk-vc-author]');
        var tl = dlg.querySelector('[data-tk-vcl-title]');
        var al = dlg.querySelector('[data-tk-vcl-author]');
        tl.textContent = t ? t.textContent : '';
        tl.href = videoUrl;
        al.textContent = a ? a.textContent : '';
        var authorUrl = slide.getAttribute('data-tk-vc-author-url');
        if (authorUrl && /^https:\/\/(www\.)?youtube\.com\//.test(authorUrl)) al.href = authorUrl;
        else al.removeAttribute('href');
        dlg.querySelector('[data-tk-vcl-yt]').href = videoUrl;

        dlg._returnTo = opener || null;
        document.documentElement.classList.add('tk-vcl-open');
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
        // Fokus na obal, ne na křížek (viz komentář u markupu) — autofocus některé
        // prohlížeče u dynamicky vloženého dialogu ignorují, proto i explicitně.
        var inner = dlg.querySelector('.tk-vcl__inner');
        if (inner) { try { inner.focus({ preventScroll: true }); } catch (err) {} }
        // Animace až po zobrazení (jinak transition neproběhne)
        requestAnimationFrame(function () { dlg.classList.add('is-open'); });
      },
    };
  }

  function getLightbox(root) {
    if (!lightbox) lightbox = buildLightbox(root.getAttribute('data-close-label'), root.getAttribute('data-yt-label'));
    return lightbox;
  }

  /* ────────────────────────── pás ────────────────────────── */
  function init(root) {
    if (root.dataset.tkVcInit === '1') return;
    root.dataset.tkVcInit = '1';

    var track = root.querySelector('[data-tk-vc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tk-vc-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-tk-vc-dot]'));
    var counter = root.querySelector('[data-tk-vc-counter]');
    var prev = root.querySelector('[data-tk-vc-prev]');
    var next = root.querySelector('[data-tk-vc-next]');
    if (!track || !slides.length) return;

    var index = 0;
    var suppressClick = false;

    function slideLeft(i) {
      return slides[i].offsetLeft - track.offsetLeft;
    }

    function nearestIndex() {
      var x = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slideLeft(i) - x);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      // Dojeté na konec = poslední slide, i když jeho začátek není na kraji
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
      return best;
    }

    function render() {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', String(i === index));
      });
      if (counter) counter.textContent = index + 1 + ' / ' + slides.length;
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slideLeft(i), behavior: smooth === false ? 'auto' : 'smooth' });
    }

    function updateStatic() {
      var overflow = track.scrollWidth > track.clientWidth + 1;
      root.classList.toggle('tk-vc--static', !overflow);
      render();
    }

    /* ── ovládání ── */
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { go(i); }); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        index = nearestIndex();
        render();
      });
    }, { passive: true });

    /* ── klik na náhled → lightbox (capture, ať ho tah nepustí dál) ── */
    root.addEventListener('click', function (e) {
      if (suppressClick) { e.stopPropagation(); e.preventDefault(); return; }
      var opener = e.target.closest && e.target.closest('[data-tk-vc-open]');
      if (!opener) return;
      e.preventDefault();
      var slide = opener.closest('[data-tk-vc-slide]');
      if (slide) getLightbox(root).open(slide, opener);
    }, true);

    /* ── tažení myší ── */
    var drag = null;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 5) return;
        drag.moved = true;
        root.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      e.preventDefault();
      track.scrollLeft = drag.left - dx;
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var moved = drag.moved;
      drag = null;
      if (!moved) return;
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      root.classList.remove('is-dragging');
      // Tah vyrobí i click — spadl by na náhled pod kurzorem a otevřel lightbox.
      suppressClick = true;
      setTimeout(function () { suppressClick = false; }, 0);
      go(nearestIndex());
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateStatic).observe(track);
    } else {
      window.addEventListener('resize', updateStatic);
    }
    updateStatic();
    watchMeta(root);
  }

  /* ── název + autor z oEmbed ── */
  function fillCaption(slide, meta) {
    var t = slide.querySelector('[data-tk-vc-title]');
    var a = slide.querySelector('[data-tk-vc-author]');
    if (t && meta.title) { t.textContent = meta.title; t.title = meta.title; slide.classList.add('has-meta'); }
    if (a && meta.author) a.textContent = meta.author;
    if (meta.authorUrl) slide.setAttribute('data-tk-vc-author-url', meta.authorUrl);
    var facade = slide.querySelector('[data-tk-vc-open]');
    if (facade && meta.title && !facade.dataset.tkLabeled) {
      facade.dataset.tkLabeled = '1';
      facade.setAttribute('aria-label', facade.getAttribute('aria-label') + ': ' + meta.title);
    }
  }

  function loadMeta(slide) {
    var id = slide.getAttribute('data-tk-vc-yt');
    if (!id || slide.dataset.tkVcMeta === '1') return;
    slide.dataset.tkVcMeta = '1';
    var key = 'tkyt2:' + id; // v2 = navíc authorUrl (starý klíč tkyt: by odkaz na kanál neměl)
    try {
      var cached = sessionStorage.getItem(key);
      if (cached) { fillCaption(slide, JSON.parse(cached)); return; }
    } catch (e) {}
    if (!window.fetch) return;
    fetch('https://www.youtube.com/oembed?format=json&url=' + encodeURIComponent('https://www.youtube.com/watch?v=' + id))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        var meta = { title: d.title || '', author: d.author_name || '', authorUrl: d.author_url || '' };
        try { sessionStorage.setItem(key, JSON.stringify(meta)); } catch (e) {}
        fillCaption(slide, meta);
      })
      .catch(function () {});
  }

  function watchMeta(root) {
    var slides = root.querySelectorAll('[data-tk-vc-slide]');
    if (!('IntersectionObserver' in window)) {
      slides.forEach(loadMeta);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        slides.forEach(loadMeta);
      });
    }, { rootMargin: '300px 0px' });
    io.observe(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tk-video-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('tk:product-tabs-updated', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
